import { render } from "./ListItemNewsletter.vue?vue&type=template&id=5add9756&scoped=true"
import script from "./ListItemNewsletter.vue?vue&type=script&lang=js"
export * from "./ListItemNewsletter.vue?vue&type=script&lang=js"

import "./ListItemNewsletter.vue?vue&type=style&index=0&id=5add9756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5add9756"]])

export default __exports__